export default "__VITE_ASSET__0444c7f1__"